import { useEffect, useState, Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, Divider, Modal, Typography, useMediaQuery } from '@mui/material';
import GuestHome from './components/pages/GuestHome';
import PrimaryBlueButton from './components/common/buttons/PrimaryBlueButton';
import CustomTitleWithBlueBackground from './components/common/CustomTitleWithBlueBackground';
import { useThemeContext } from './contexts/BaseThemeContextProvider';
import GhostButton from './components/common/buttons/GhostButton';
import BorderedButton from './components/common/buttons/BorderedButton';
import { colors, fonts } from './styles/fontStyles.js';
import { fetchCognitoUserToken } from './utils/user';

const backendURL = process.env.REACT_APP_BACKEND_URL;

export default function Home({ user }) {
  const navigate = useNavigate();
  const { theme } = useThemeContext();

  const { cognitoUserInfo } = useThemeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [modalOpen, setModalOpen] = useState(false);
  const handleModalClose = () => setModalOpen(false);
  const updateSmsOptin = async (sms_flag) => {
    let access_token = await fetchCognitoUserToken();
    fetch(`${backendURL}/users/sms-optin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=UTF-8', Authorization: 'Bearer ' + access_token },
      body: JSON.stringify({ sms_flag: sms_flag }),
    })
      .then((res) => {
        res.json().then((response) => {
          sessionStorage.setItem('sms.opt-in.remindLater', false);
        });
      })
      .catch((err) => {
        sessionStorage.setItem('sms.opt-in.remindLater', true);
      });
  };
  const handleModalYes = () => {
    updateSmsOptin(1);
    setModalOpen(false);
  };
  const handleModalNo = () => {
    updateSmsOptin(0);
    setModalOpen(false);
  };
  const handleModalRemindMeLater = () => {
    sessionStorage.setItem('sms.opt-in.remindLater', true);
    setModalOpen(false);
  };
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '100%', md: '500px' },
    maxHeight: '90vh',
    overflowY: 'auto',
    bgcolor: theme.custom.messages.modalStyle.backgroundColor,
    border: '0.5px solid #EEE',
    borderRadius: '20px',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    p: 4,
    color: theme.custom.messages.modalStyle.color,
  };

  useEffect(() => {
    if (!cognitoUserInfo || !cognitoUserInfo?.attributes) return;

    const remindLaterFlag = sessionStorage.getItem('sms.opt-in.remindLater');

    const sms_flag = cognitoUserInfo?.attributes['custom:sms_flag'];
    if ((!sms_flag || sms_flag > 1) && !remindLaterFlag) {
      setModalOpen(true);
    } else {
      setModalOpen(false);
    }
  }, [cognitoUserInfo]);

  const renderRegisteredUserContent = () => {
    return (
      <>
        {/* upper section */}
        <Box
          sx={{
            display: 'flex',
            padding: '24px',
            marginTop: '16px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '80px',
            alignSelf: 'stretch',
            backgroundColor: theme.custom.pages.auth.home.backgroundColor,
            borderRadius: '16px',
            [theme.breakpoints.down('md')]: {
              alignItems: 'center',
              flexDirection: 'column',
              textAlign: 'center',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: { xs: 'center', md: 'flex-start' },
              gap: '16px',
              alignSelf: 'stretch',
              flexDirection: { xs: 'column', md: 'row' },
              width: '100%',
            }}
          >
            {/* Left image section */}
            <Box
              component="img"
              src={'/images/registered-user-home-1.png'}
              alt="Home"
              sx={{
                alignItems: 'center',
                width: '380px',
                height: '180px',
                borderRadius: '16px',
              }}
            />

            {/* Right Text Section */}
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                sx={{
                  typography: { sm: 'h5', md: 'h4' },
                  color: theme.custom.pages.auth.home.typography.color,
                  alignSelf: 'stretch',
                  fontSize: '57px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '64px',
                  letterSpacing: '-0.25px',
                  marginBottom: '10px',
                }}
              >
                Welcome back {cognitoUserInfo?.attributes?.name}
              </Typography>
              <Typography
                sx={{
                  alignSelf: 'stretch',
                  fontSize: '18px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '28px',
                  marginBottom: '50px',
                  color: theme.custom.pages.auth.home.typography.subHeader.color,
                }}
              >
                What would you like to do?
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  gap: '8px',
                  flexDirection: { xs: 'column', md: 'row' },
                  justifyContent: { xs: 'center', md: 'flex-start' },
                  maxWidth: { xs: '100%', sm: '100%' },
                  padding: { xs: '0 24px', sm: '0' },
                  width: { xs: '100%', sm: '100%' },
                  margin: { xs: '0', sm: '0 auto', md: '0' },
                }}
              >
                <PrimaryBlueButton
                  sxProps={{
                    display: 'flex',
                    padding: '10px 16px 10px 16px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '4px',
                    alignSelf: 'stretch',
                    width: { xs: '100%', md: '140px' },
                  }}
                  additionalProps={{
                    style: { borderRadius: '100px', height: '48px' },
                    startIcon: (
                      <img
                        src={'/icons/shopping_cart_white.svg'}
                        alt={'Order test'}
                        style={{ width: '18px', height: '18px' }}
                      />
                    ),
                    component: Link,
                    to: process.env.REACT_APP_PRODUCT_PAGE_URL,
                    target: '_blank',
                  }}
                  buttonText={'Order test'}
                />
                <BorderedButton
                  sxProps={{
                    display: 'flex',
                    padding: '10px 16px 10px 16px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '4px',
                    alignSelf: 'stretch',
                    width: { xs: '100%', md: '150px' },
                    '& .MuiButton-startIcon': {
                      height: '18px',
                      width: '18px',
                      backgroundImage: `url(${theme.images.activateKitIcon.default})`,
                    },
                    '&:hover': {
                      background: 'transparent',
                      color: theme.buttons.ghost.hover.color,
                      border: '2px solid',
                      '& .MuiButton-startIcon': {
                        height: '18px',
                        width: '18px',
                        backgroundImage: `url(${theme.images.activateKitIcon.hover})`,
                      },
                    },
                  }}
                  additionalProps={{
                    style: { borderRadius: '100px', height: '48px' },
                    // Needed so the icon styles work as expected
                    startIcon: <></>,
                  }}
                  onClick={() => navigate('/activate.html')}
                  buttonText="Activate test"
                />
                <GhostButton
                  sxProps={{
                    display: 'flex',
                    padding: '2px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '2px',
                    alignSelf: 'stretch',
                    width: { xs: '100%', md: '115px' },
                    '& .MuiButton-startIcon': {
                      height: '18px',
                      width: '18px',
                      backgroundImage: `url(${theme.images.viewResultsIcon.default})`,
                    },
                    '&:hover': {
                      background: 'transparent',
                      color: theme.buttons.ghost.hover.color,
                      border: '2px solid',
                      '& .MuiButton-startIcon': {
                        height: '18px',
                        width: '18px',
                        backgroundImage: `url(${theme.images.viewResultsIcon.hover})`,
                      },
                    },
                  }}
                  additionalProps={{
                    style: { border: 'none', height: '48px' },
                    startIcon: <></>,
                  }}
                  onClick={() => navigate('/results.html')}
                  buttonText="View results"
                />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: { xs: 'center', md: 'flex-start' },
              gap: '32px',
              alignSelf: 'stretch',
              flexDirection: { xs: 'column', md: 'row' },
              width: '100%',
            }}
          >
            {/* left text section */}
            <Box
              sx={{
                display: 'flex',
                maxWidth: 600,
                flexDirection: 'column',
              }}
            >
              <Typography
                sx={{
                  typography: { sm: 'h5', md: 'h3' },
                  color: theme.custom.pages.auth.home.typography.color,
                  alignSelf: 'stretch',
                  fontSize: '57px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '64px',
                  letterSpacing: '-0.25px',
                  marginBottom: '8px',
                }}
              >
                At-home PFAS and toxin testing
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'center', sm: 'center', md: 'flex-start' },
                  width: '100%',
                }}
              >
                <CustomTitleWithBlueBackground
                  parentSxProps={{
                    alignItems: { xs: 'center', sm: 'center', md: 'flex-start' },
                  }}
                  text={
                    isMobile
                      ? 'Helping everyone live\nhealthier lives in\nthe face of toxin exposure'
                      : 'Helping everyone live healthier\nlives in the face of toxin\nexposure'
                  }
                />
              </Box>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  color: theme.custom.pages.auth.home.typography.color,
                  fontSize: '28px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '36px',
                  marginTop: '40px',
                  marginBottom: '8px',
                }}
              >
                Minimally invasive PFAS tests
              </Typography>
              <Typography
                sx={{
                  color: theme.custom.pages.auth.home.typography.color,
                  mt: 0.5,
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '20px',
                  letterSpacing: '0.25px',
                  marginBottom: '32px',
                }}
              >
                Our PFAS test is designed to be reliable and convenient. The test can be taken in the comfort of your
                home, with results available in our app within days. Results are added to a timeline so you can track
                your exposure over time.
              </Typography>
            </Box>
            {/* right image section */}
            <Box
              component="img"
              src={'/images/registered-user-home-2.png'}
              alt="Home"
              sx={{
                alignItems: 'center',
                width: '380px',
                height: '365px',
                borderRadius: '16px',
              }}
            />
          </Box>

          <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <Box sx={modalStyle}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography
                  id="modal-title"
                  variant="h6"
                  component="h2"
                  sx={{
                    color: theme.custom.messages.modal.labelColor,
                    fontFamily: fonts.regular,
                    fontSize: '20px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: '20px',
                    letterSpacing: '0.1px',
                  }}
                >
                  Enroll in text notifications
                </Typography>
              </Box>
              <Divider sx={{ my: 2, bgcolor: theme.custom.messages.modal.dividerColor }} />
              <Typography
                id="modal-description"
                sx={{
                  textAlign: 'left',
                  mb: 2,
                  color: theme.custom.messages.modal.descriptionColor,
                  fontFamily: fonts.regular,
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '20px',
                  letterSpacing: '0.25px',
                  wordWrap: 'break-word',
                  '& a': {
                    color: theme.custom.messages.modal.linkColor,
                  },
                }}
              >
                I agree to get SMS from Relentless Health for updates, results, reminders, offers, one-time-passcodes
                (OTP), etc. Up to 2 messages per day, plus OTPs for Sign In. Message and data rates may apply. Reply
                STOP to opt out or HELP for more information. View our{' '}
                <Link
                  style={{
                    color: theme.custom.components.signupStep1AccountDetails.typography.secondary.color,
                    textDecoration: 'none',
                  }}
                  to="/tos.html"
                  target="blank"
                >
                  {' '}
                  Terms of Service{' '}
                </Link>
                and{' '}
                <Link
                  style={{
                    color: theme.custom.components.signupStep1AccountDetails.typography.secondary.color,
                    textDecoration: 'none',
                  }}
                  to="/privacy-policy.html"
                  target="blank"
                >
                  {' '}
                  Privacy Policy
                </Link>
                .
              </Typography>
              <Divider sx={{ my: 2, bgcolor: theme.custom.messages.modal.dividerColor }} />
              <Box
                sx={{
                  display: 'flex',
                  gap: '8px',
                  flexDirection: { xs: 'column', md: 'row' },
                  justifyContent: { xs: 'center', md: 'flex-start' },
                  maxWidth: { xs: '100%', sm: '100%' },
                  padding: { xs: '0 24px', sm: '0' },
                  width: { xs: '100%', sm: '100%' },
                  margin: { xs: '0', sm: '0 auto', md: '0' },
                }}
              >
                <PrimaryBlueButton
                  onClick={handleModalYes}
                  buttonText="Yes"
                  sxProps={{
                    display: 'flex',
                    padding: '10px 16px 10px 16px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '4px',
                    alignSelf: 'stretch',
                    width: { xs: '100%', md: '100px' },
                  }}
                >
                  Yes
                </PrimaryBlueButton>
                <BorderedButton
                  sxProps={{
                    display: 'flex',
                    padding: '10px 16px 10px 16px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '4px',
                    alignSelf: 'stretch',
                    width: { xs: '100%', md: '100px' },
                    '& .MuiButton-startIcon': {
                      height: '18px',
                      width: '18px',
                    },
                    '&:hover': {
                      background: 'transparent',
                      color: theme.buttons.ghost.hover.color,
                      border: '2px solid',
                      '& .MuiButton-startIcon': {
                        height: '18px',
                        width: '18px',
                      },
                    },
                  }}
                  onClick={handleModalNo}
                  buttonText="No"
                />
                <GhostButton
                  sxProps={{
                    display: 'flex',
                    padding: '2px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '2px',
                    alignSelf: 'stretch',
                    width: { xs: '100%', md: '140px' },
                    '& .MuiButton-startIcon': {
                      height: '18px',
                      width: '18px',
                    },
                    '&:hover': {
                      background: 'transparent',
                      color: theme.buttons.ghost.hover.color,
                      border: '2px solid',
                      '& .MuiButton-startIcon': {
                        height: '18px',
                        width: '18px',
                      },
                    },
                  }}
                  additionalProps={{
                    style: { border: 'none', height: '48px' },
                    startIcon: <></>,
                  }}
                  onClick={handleModalRemindMeLater}
                  buttonText="Remind me later"
                />
              </Box>
            </Box>
          </Modal>
        </Box>
      </>
    );
  };

  return <>{user ? renderRegisteredUserContent(user) : <GuestHome imageSrc={'/images/guest-home.png'} />}</>;
}
